import { render, staticRenderFns } from "./p-tab-form.vue?vue&type=template&id=8726edd4&"
import script from "./p-tab-form.vue?vue&type=script&lang=js&"
export * from "./p-tab-form.vue?vue&type=script&lang=js&"
import style0 from "./p-tab-form.vue?vue&type=style&index=0&id=8726edd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports